import HomeIconInactive from "components/icons/FooterIcons/homeIconInactive.svg?react";
import HomeIconActive from "components/icons/FooterIcons/homeIconActive.svg?react";
import ExploreIconActive from "components/icons/FooterIcons/exploreIconActive.svg?react";
import ExploreIconInactive from "components/icons/FooterIcons/exploreIconInactive.svg?react";
import CategoryIconInactive from "components/icons/FooterIcons/categoryIcon.svg?react";
import CategoryIconActive from "components/icons/FooterIcons/categoryActiveIcon.svg?react";
import PlusIcon from "components/icons/plusThink.svg?react";
import BookmarkIconActive from "components/icons/FooterIcons/bookmarkIconActive.svg?react";
import BookmarkIconInactive from "components/icons/FooterIcons/bookmarkIconInactive.svg?react";
import ProfileIconActive from "components/icons/FooterIcons/profileIconActive.svg?react";
import ProfileIconInactive from "components/icons/FooterIcons/profileIconInactive.svg?react";
import { clsx } from "clsx";
import { TabLink } from "../TabLink";
import { routes } from "routes";
import { TABS } from "./helpers";
import "./ApplicationFooter.scss";

interface IApplicationFooterProps {
  currentUserName: string | null;
  onSendMetricAndCloseMenu: (tabName: string) => void;
  isTabActive: (tab: string) => string | boolean | null;
  onProfileClick: () => void;
}

export const ApplicationFooter: React.FC<IApplicationFooterProps> = ({
  currentUserName,
  onSendMetricAndCloseMenu,
  isTabActive,
  onProfileClick
}) => {
  const footerTabs = [
    {
      to: routes.home(),
      type: TABS.home,
      label: "Home",
      alwaysShow: true,
      onClick: () => onSendMetricAndCloseMenu(TABS.home),
      icon: isTabActive(TABS.home) ? <HomeIconActive /> : <HomeIconInactive />
    },
    {
      to: routes.explore(),
      type: TABS.explore,
      label: "Explore",
      alwaysShow: true,
      onClick: () => onSendMetricAndCloseMenu(TABS.explore),
      icon: isTabActive(TABS.explore) ? <ExploreIconActive /> : <ExploreIconInactive />
    },
    {
      to: routes.create(),
      type: TABS.add,
      label: "Upload",
      alwaysShow: true,
      onClick: () => onSendMetricAndCloseMenu(TABS.add),
      icon: <PlusIcon />
    },
    {
      to: routes.userCollections(currentUserName || ""),
      type: TABS.saved,
      label: "Saved",
      alwaysShow: false,
      condition: !!currentUserName,
      onClick: () => onSendMetricAndCloseMenu(TABS.saved),
      icon: isTabActive(TABS.saved) ? <BookmarkIconActive /> : <BookmarkIconInactive />
    },
    {
      to: routes.trendingTags(),
      type: TABS.categories,
      label: "Categories",
      alwaysShow: false,
      condition: !currentUserName,
      onClick: () => onSendMetricAndCloseMenu(TABS.categories),
      icon: isTabActive(TABS.categories) ? <CategoryIconActive /> : <CategoryIconInactive />
    }
  ];

  return (
    <div className="ApplicationFooter">
      {footerTabs.map(tab => (tab.alwaysShow || tab.condition) && (
        <TabLink key={tab.type} tab={tab} isActive={!!isTabActive(tab.type)} />
      ))}
      <button
        className={clsx(
          "TabLink",
          "TabLink_isProfile",
          isTabActive(TABS.profile) && "TabLink_isActive",
        )}
        onClick={onProfileClick}
        aria-label={`${currentUserName ?? "Log in"}`}
      >
        <div>{isTabActive(TABS.profile) ? <ProfileIconActive /> : <ProfileIconInactive />}</div>
        <span>{ currentUserName ?? "Log in" }</span>
      </button>
    </div>
  );
};
